module.exports = __webpack_public_path__ + "img/pic01.36381323.jpg";